import React, { useEffect, useState } from "react";
import { Routes, Route, useLocation } from "react-router-dom";
import LanguageHandler from "./shared/components/LanguageHandler";
import Aos from "aos";

import AdminLayout from "./dashboard/shared/layout/AdminLayout";
import Layout from "./shared/layout/Layout";
import AuthLayout from "./auth/AuthLayout";

import { adminRoutes } from "./shared/routes/configs/adminRoutes";
import { studentRoutes } from "./shared/routes/configs/studentRoutes";

import "./shared/assets/global.css";
import LoaderImage from "./shared/assets/images/loader.svg.png";

const Loader = () => (
  <div className="loader-container">
    <img className="loaderImage" src={LoaderImage} alt="" />
    <section className="loader">
      <div className="slider" style={{ "--i": 0 }}></div>
      <div className="slider" style={{ "--i": 1 }}></div>
      <div className="slider" style={{ "--i": 2 }}></div>
      <div className="slider" style={{ "--i": 3 }}></div>
      <div className="slider" style={{ "--i": 4 }}></div>
    </section>
  </div>
);

const TelegramSubscribe = ({ onClose }) => (
  <div>
    <div className="modal-overlay" onClick={onClose}></div>

    <div className="telegram-subscribe-container">
      <div className="telegram-subscribe">
        <button className="close-btn" onClick={onClose}>
          &times;
        </button>
        <div className="allCollected">
          <div className="imageCollected">
            <img
              src="https://site.renessans-edu.uz/media/logo.jpg" // Replace with your own Telegram logo if needed
              alt="Telegram"
              className="telegram-logo"
            />
            <p>
              Renessans universitetining yangi web sayti test rejimida ishlamoqda
            </p>
          </div>
          <div className="collected">
            {/* <a
              href="https://t.me/renessansedu_uz"
              target="_blank"
              rel="noopener noreferrer"
              className="telegram-link"
            >
              A'zo bo'lish  
              <IoSendOutline />
            </a> */}
          </div>
        </div>
      </div>
    </div>
  </div>
);

const App = () => {
  const location = useLocation();
  const { pathname } = location;
  const [loading, setLoading] = useState(true);

  const handleDisplayLayouts = () => {
    if (pathname.includes("admin")) {
      return <AdminLayout routes={adminRoutes} />;
    }

    if (pathname.includes("student")) {
      return <AdminLayout routes={studentRoutes} />;
    }

    if (pathname.includes("auth")) {
      return <AuthLayout />;
    }

    return <Layout />;
  };

  useEffect(() => {
    Aos.init({
      duration: 1000,
      mirror: true,
      once: false,
    });
    const timer = setTimeout(() => setLoading(false), 3000);

    return () => {
      clearTimeout(timer);
    };
  }, []);

  if (loading) {
    return <Loader />;
  }

  return (
    <div id="zoom-root" className="App">
      <Routes>
        <Route
          path="/:lang/*"
          element={<LanguageHandler>{handleDisplayLayouts()}</LanguageHandler>}
        />
        <Route
          path="*"
          element={<LanguageHandler>{handleDisplayLayouts()}</LanguageHandler>}
        />
      </Routes>
    </div>
  );
};

export default App;
